import { Dispatch, SetStateAction, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import styles from "./Upload.module.css";
import { Typography } from "@mui/material";
import uploadImage from "../../assets/uploadImage.svg";
import uploadedPdf from "../../assets/uploadedPdf.svg";
import closeIcon from "../../assets/closeIcon.svg";
import { useSnackbar } from "../../context/SnackbarContext";

interface Props {
  file: File | null;
  setFile: Dispatch<SetStateAction<File | null>>;
}

const UploadResume = ({ file, setFile }: Props) => {
  const { showSnackbar } = useSnackbar();

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const acceptedFile = acceptedFiles[0];

    if (acceptedFile) {
      const fileSizeInMB = acceptedFile.size / (1024 * 1024); // Convert size to MB

      if (fileSizeInMB > 50) {
        // Replace this with your error handling logic
        console.error("File size exceeds 50 MB. Please upload a smaller file.");
        showSnackbar(
          "File size exceeds 50 MB. Please upload a smaller file.",
          "error"
        );
        return;
      }

      setFile(acceptedFile);
    }
  }, []);

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    noClick: true,
    accept: {
      "application/pdf": [".pdf"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
    },
  });

  const removeFile = () => {
    setFile(null);
  };

  return (
    <div {...getRootProps()} className={styles.dropzone}>
      <input {...getInputProps()} />
      <div>
        <img src={uploadImage} alt="Upload" />
      </div>
      <Typography component="p">
        Drop your file here, or{" "}
        <div onClick={open} className={styles.browseBtn}>
          browse
        </div>
      </Typography>
      <Typography component="p">Supports: PDF, DOC</Typography>
      <Typography component="p">Max Size: 50MB</Typography>
      {file && (
        <div className={styles.uploadedContainer}>
          <div className={styles.uploadedDesc}>
            <img src={uploadedPdf} alt="pdf" className={styles.pdfImage} />
            <p>
              {file.name.length > 12
                ? file?.name?.slice(0, 12) + "..."
                : file.name}
            </p>
          </div>
          <img
            width={14}
            src={closeIcon}
            alt="close"
            onClick={removeFile}
            className="uploadedRemove"
          />
        </div>
      )}
    </div>
  );
};

export default UploadResume;
